module.exports = __webpack_public_path__ + "media/ru_ru_s1_Anya.b3a5773f.mp3";